module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', [_c('div', {
    staticClass: "questionNums"
  }, [_c('span', [_vm._v(_vm._s(_vm.examIndex + 1))]), _vm._v("/ 共" + _vm._s(_vm.questionNum) + "题")]), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', _vm._l((_vm.questionLists), function(questionsItem, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.examIndex === index ? true : false),
        expression: "examIndex === index ? true :false"
      }],
      key: index,
      staticClass: "option-div"
    }, [(questionsItem.type == '001001') ? _c('h2', {
      staticClass: "questionTitle"
    }, [_c('span', [_vm._v("「单选」")]), _vm._v(_vm._s(questionsItem.content))]) : _vm._e(), _vm._v(" "), (questionsItem.type == '001002') ? _c('h2', {
      staticClass: "questionTitle"
    }, [_c('span', [_vm._v("「多选」")]), _vm._v(_vm._s(questionsItem.content))]) : _vm._e(), _vm._v(" "), (questionsItem.type == '001003') ? _c('h2', {
      staticClass: "questionTitle"
    }, [_c('span', [_vm._v("「判断」")]), _vm._v(_vm._s(questionsItem.content))]) : _vm._e(), _vm._v(" "), _vm._l((questionsItem.choices), function(choicesItem, index) {
      return _c('div', {
        key: index,
        staticClass: "option-list-radio cb"
      }, [(questionsItem.type == '001001') ? _c('div', {
        staticStyle: {
          "display": "flex",
          "align-items": "center"
        }
      }, [_c('van-radio', {
        attrs: {
          "name": choicesItem.code
        },
        on: {
          "click": _vm.radioChange
        },
        model: {
          value: (questionsItem.userAnswer),
          callback: function($$v) {
            _vm.$set(questionsItem, "userAnswer", $$v)
          },
          expression: "questionsItem.userAnswer"
        }
      }, [_vm._v(_vm._s(choicesItem.code) + ".")]), _vm._v(" "), _c('div', [_c('span', {
        staticClass: "exam-words fl",
        domProps: {
          "innerHTML": _vm._s(choicesItem.content)
        }
      })])], 1) : _vm._e(), _vm._v(" "), (questionsItem.type == '001002') ? _c('div', {
        staticStyle: {
          "display": "flex",
          "align-items": "center"
        }
      }, [_c('van-checkbox-group', {
        model: {
          value: (questionsItem.userAnswer),
          callback: function($$v) {
            _vm.$set(questionsItem, "userAnswer", $$v)
          },
          expression: "questionsItem.userAnswer"
        }
      }, [_c('van-checkbox', {
        attrs: {
          "name": choicesItem.code
        },
        on: {
          "click": _vm.radioChange
        }
      }, [_vm._v(_vm._s(choicesItem.code) + ".")])], 1), _vm._v(" "), _c('div', [_c('span', {
        staticClass: "exam-words fl",
        domProps: {
          "innerHTML": _vm._s(choicesItem.content)
        }
      })])], 1) : _vm._e(), _vm._v(" "), (questionsItem.type == '001003') ? _c('div', {
        staticStyle: {
          "display": "flex",
          "align-items": "center"
        }
      }, [_c('van-radio', {
        attrs: {
          "name": choicesItem.code
        },
        on: {
          "click": _vm.radioChange
        },
        model: {
          value: (questionsItem.userAnswer),
          callback: function($$v) {
            _vm.$set(questionsItem, "userAnswer", $$v)
          },
          expression: "questionsItem.userAnswer"
        }
      }, [_vm._v(_vm._s(choicesItem.code) + ".")]), _vm._v(" "), _c('div', [_c('span', {
        staticClass: "exam-words fl",
        domProps: {
          "innerHTML": _vm._s(choicesItem.content)
        }
      })])], 1) : _vm._e()])
    }), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "rightKey"
    }, [_c('span', [_vm._v("正确答案" + _vm._s(questionsItem.answer))])]), _vm._v(" "), _c('div', {
      staticClass: "analysis",
      on: {
        "click": function($event) {
          return _vm.log()
        }
      }
    }, [_vm._v("「本题解析」\n                        "), _c('div', {
      staticClass: "personalAnalysis",
      domProps: {
        "innerHTML": _vm._s(questionsItem.analysis)
      }
    })])])], 2)
  }), 0)]), _vm._v(" "), _c('div', [(!_vm.show) ? _c('van-cell', {
    staticClass: "examFooters"
  }, [_c('van-button', {
    staticClass: "questionbtn",
    attrs: {
      "plain": "",
      "type": "danger"
    },
    on: {
      "click": _vm.lastQuestion
    }
  }, [_vm._v("上一题")]), _vm._v(" "), _c('van-button', {
    staticClass: "questionbtn",
    attrs: {
      "plain": "",
      "type": "danger"
    },
    on: {
      "click": _vm.nextQuestion
    }
  }, [_vm._v("下一题")]), _vm._v(" "), _c('a', {
    attrs: {
      "javascript:": ""
    },
    on: {
      "click": _vm.showPopup
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/mobile/answerSheet.png"),
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.examIndex + 1) + "/" + _vm._s(_vm.questionNum))])], 1) : _vm._e(), _vm._v(" "), _c('van-popup', {
    attrs: {
      "overlay": false,
      "position": "bottom"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('van-cell', {
    staticClass: "examFooter"
  }, [_c('van-button', {
    staticClass: "questionbtn",
    attrs: {
      "plain": "",
      "type": "danger"
    },
    on: {
      "click": _vm.lastQuestion
    }
  }, [_vm._v("上一题")]), _vm._v(" "), _c('van-button', {
    staticClass: "questionbtn",
    attrs: {
      "plain": "",
      "type": "danger"
    },
    on: {
      "click": _vm.nextQuestion
    }
  }, [_vm._v("下一题")]), _vm._v(" "), _c('a', {
    attrs: {
      "javascript:": ""
    },
    on: {
      "click": _vm.showPopup
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/mobile/answerSheet.png"),
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.examIndex + 1) + "/" + _vm._s(_vm.questionNum))])], 1), _vm._v(" "), _vm._l((_vm.questionLists), function(item, index) {
    return _c('van-button', {
      key: index,
      staticClass: "questionAnswer",
      class: [index === _vm.examIndex ? 'active1' : '', {
        unanswered: typeof(item.userAnswer) != 'undefined' && item.userAnswer.length != 0
      }],
      attrs: {
        "plain": "",
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.selecteQuestion(index)
        }
      }
    }, [_vm._v(_vm._s(index + 1))])
  })], 2)], 1), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "className": "examResults",
      "showConfirmButton": false,
      "title": "考试成绩"
    },
    model: {
      value: (_vm.examResults),
      callback: function($$v) {
        _vm.examResults = $$v
      },
      expression: "examResults"
    }
  }, [_c('van-icon', {
    staticClass: "cross",
    attrs: {
      "name": "cross"
    },
    on: {
      "click": function($event) {
        _vm.examResults = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fraction"
  }, [_vm._v("您的得分 "), _c('span', [_vm._v(_vm._s(_vm.questionTotals.score))]), _vm._v(" /" + _vm._s(_vm.questionTotals.totalScore))]), _vm._v(" "), _c('div', {
    staticClass: "fraction"
  }, [_vm._v("答对题数  "), _c('span', [_vm._v(_vm._s(_vm.questionTotals.questionCount))]), _vm._v(" /" + _vm._s(_vm.questionTotals.totalQuestionCount))]), _vm._v(" "), _c('div', {
    staticClass: "fraction"
  }, [_vm._v("答错题数  "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.questionScores[0].error))]), _vm._v(" /" + _vm._s(_vm.questionTotals.totalQuestionCount))]), _vm._v(" "), _c('div', {
    staticClass: "wrongQuestions"
  }, [_c('van-button', {
    attrs: {
      "round": "",
      "type": "info"
    },
    on: {
      "click": _vm.wrongQuestions
    }
  }, [_vm._v("错题解析")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-5af35e57"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/MobileExamAnalysis.vue
// module id = 1157
// module chunks = 41